// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  padding: 25px;
  align-content: center;
  background-color: #07112e;
  font-size: 0.875rem;
  letter-spacing: 1px;
}

footer .copy {
  font-size: 0.875rem;
  color: grey;
  line-height: 17px;
  font-weight: 400;
  text-align: center;
}

.media i {
  cursor: pointer;
  color: #ffffff;
}
.media i:hover {
  color: #0080ff;
}

td {
  font-size: 0.875rem;
  padding-top: 12px;
  padding-right: 160px;
  text-align: left;
  font-weight: 300;
  cursor: pointer;
}
td:hover {
  color: #0080ff;
}

a {
  text-decoration: none;
  color: #ffffff;
}
a:hover {
  color: #0080ff;
}

th {
  font-size: 1rem;
  font-weight: 400;
  padding-bottom: 10px;
  padding-right: 160px;
  text-align: left;
}

.policies a {
  padding: 3px 10px;
  cursor: pointer;
}

#pol {
  border-right: 2px solid #646568;
}

.request-btn {
  color: #2b326d;
  font-weight: 500;
  background: linear-gradient(45deg, #91a4fa 10%, #17f5d0 100%);
  cursor: pointer;
}

.request-btn:hover {
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.24), 0 17px 50px 0 rgba(0, 0, 0, 0.19);
  transition-duration: 0.4s;
}`, "",{"version":3,"sources":["webpack://./src/app/footer/footer.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EAEA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAAJ;;AAEE;EACE,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AACJ;;AAEE;EACE,eAAA;EACA,cAAA;AACJ;AAAI;EACE,cAAA;AAEN;;AAEG;EACC,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AACJ;AACI;EACE,cAAA;AACN;;AAGG;EACC,qBAAA;EACA,cAAA;AAAJ;AACK;EACC,cAAA;AACN;;AAKG;EACC,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,gBAAA;AAFJ;;AAKG;EACC,iBAAA;EACA,eAAA;AAFJ;;AAKG;EACG,+BAAA;AAFN;;AAMG;EACC,cAAA;EACA,gBAAA;EACA,6DAAA;EACA,eAAA;AAHJ;;AAME;EACE,+EAAA;EAEA,yBAAA;AAJJ","sourcesContent":["footer{\r\n    padding: 25px;\r\n    //margin-bottom: 30px;\r\n    align-content: center;\r\n    background-color: #07112e;\r\n    font-size: 0.875rem;\r\n    letter-spacing: 1px;\r\n  }\r\n  footer .copy{\r\n    font-size: 0.875rem;\r\n    color: grey;\r\n    line-height: 17px;\r\n    font-weight: 400;\r\n    text-align: center;\r\n  }\r\n\r\n  .media i{\r\n    cursor: pointer;\r\n    color: #ffffff;\r\n    &:hover{\r\n      color: #0080ff;\r\n    }\r\n  }\r\n\r\n   td {\r\n    font-size: 0.875rem;\r\n    padding-top: 12px;\r\n    padding-right: 160px;\r\n    text-align: left;\r\n    font-weight: 300;\r\n    cursor: pointer;\r\n    \r\n    &:hover{\r\n      color: #0080ff;\r\n    }\r\n   }\r\n\r\n   a{\r\n    text-decoration: none;\r\n    color: #ffffff;\r\n     &:hover{\r\n      color: #0080ff;\r\n    }\r\n   }\r\n\r\n\r\n\r\n   th{\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    padding-bottom: 10px;\r\n    padding-right: 160px;\r\n    text-align: left;\r\n   }\r\n\r\n   .policies a{\r\n    padding: 3px 10px;\r\n    cursor: pointer;\r\n   }\r\n\r\n   #pol{\r\n      border-right: 2px solid #646568;\r\n      \r\n   }\r\n\r\n   .request-btn {\r\n    color: #2b326d;\r\n    font-weight: 500;\r\n    background: linear-gradient(45deg, #91a4fa 10%, #17f5d0 100%);\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .request-btn:hover {\r\n    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.24),\r\n      0 17px 50px 0 rgba(0, 0, 0, 0.19);\r\n    transition-duration: 0.4s;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
